import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

const { Form } = Common;

const CatalogFormCustomFields = ({
  errors,
  handleValueChange,
  handleRemoveElement,
  handleAddElement,
  isSubmitted,
  t,
  values,
}) => {
  // const elements = (values.elements && values.elements.filter(e => !e.deleted)) || [];
  const elements = values.elements;
  return (
    <Form.Section title={t('catalogs.form.elements')}>
      <div className="row align-items-center">
        <div className="col-md-3" />
        <div className="col-md-6">
          <table className="table table-striped table-hover table-condensed">
            <thead>
              <tr>
                <th className="align-middle" width="40%">
                  {t('catalogs.fields.key')}
                </th>
                <th className="align-middle" width="40%">
                  {t('catalogs.fields.value')}
                </th>
                <th className="text-center align-middle" width="20%">
                  {t('common.actions')}
                </th>
              </tr>
            </thead>
            <tbody>
              {!elements.length && <Common.EmptyTable colSpan={3} />}
              {elements.map((e, index) => {
                if (e.deleted) return null;
                else
                  return (
                    <tr key={index}>
                      <td>
                        <Form.FieldInput
                          error={
                            (isSubmitted &&
                              errors[`elements[${index}]`] &&
                              errors[`elements[${index}]`].key) ||
                            {}
                          }
                          name={`elements[${index}].key`}
                          handleChange={handleValueChange}
                          value={e.key}
                          readOnly={!e.editable}
                        />
                      </td>
                      <td>
                        <Form.FieldInput
                          error={
                            (isSubmitted &&
                              errors[`elements[${index}]`] &&
                              errors[`elements[${index}]`].value) ||
                            {}
                          }
                          name={`elements[${index}].value`}
                          handleChange={handleValueChange}
                          value={t(e.value)}
                          readOnly={!e.editable}
                        />
                      </td>
                      <td>
                        {e.editable && (
                          <a
                            className="btn btn-outline-danger btn-sm"
                            href="#add-element"
                            onClick={(e) => {
                              e.preventDefault();
                              handleRemoveElement(index);
                            }}
                          >
                            {t('actions.delete')}
                          </a>
                        )}
                      </td>
                    </tr>
                  );
              })}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="2" />
                <td className="text-center">
                  {values.editable && (
                    <a
                      className="btn btn-outline-success btn-sm"
                      href="#add-element"
                      onClick={(e) => {
                        e.preventDefault();
                        handleAddElement();
                      }}
                    >
                      {t('actions.addOther')}
                    </a>
                  )}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </Form.Section>
  );
};

export default translate()(CatalogFormCustomFields);



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/components/form/sections/CatalogFormElements.js